<div class="map-table-detail-card" *ngIf="detail">
  <div class="map-table-detail-card__header">
    <div class="map-table-detail-card__title">{{ detail?.title }} - ({{ index + 1 }}/{{ details.length }})</div>
    <button color="accent" mat-icon-button (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="map-table-detail-card__body">
    <div class="map-table-detail-card__body--side-btn">
      <button
        color="accent"
        mat-icon-button
        class="side-btn--prev"
        matTooltip="Dettaglio precedente"
        (click)="onPrevDetail()"
        [disabled]="index === 0"
      >
        <mat-icon>arrow_back_ios_new</mat-icon>
      </button>
    </div>
    <app-report-dialog
      [data]="detail?.data"
      [isDialog]="true"
      [styleConfig]="customReportStyle"
      [properties]="detail?.properties"
    >
    </app-report-dialog>
    <div class="map-table-detail-card__body--side-btn">
      <button
        color="accent"
        mat-icon-button
        class="side-btn--next"
        matTooltip="Dettaglio successivo"
        (click)="onNextDetail()"
        [disabled]="index === details.length - 1"
      >
        <mat-icon>arrow_forward_ios</mat-icon>
      </button>
    </div>
  </div>
</div>
